import React from 'react'
import { motion } from 'framer-motion'
import { FaHandPaper } from 'react-icons/fa'

const ProblemSection = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <motion.div 
          className="text-center max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >          
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Vous aimez votre métier. Vos articulations, moins.
          </h2>
          
          <div className="mb-6 flex justify-center">
            <img src="/images/pains.png" alt="Douleurs lors des séances d'EMDR" className="w-1/2 rounded-lg" />
          </div>
          
          <p className="text-lg text-gray-600 leading-relaxed">
            Les séances d'EMDR s'enchaînent et la fatigue physique s'installe. Douleurs à l'épaule, 
            au poignet, au dos... Cette gêne récurrente peut nuire à votre concentration et, à long terme, 
            à votre propre bien-être. Et si vous pouviez mener des séances tout aussi efficaces, 
            voire plus, sans jamais avoir à lever la main ?
          </p>
        </motion.div>
      </div>
    </section>
  )
}

export default ProblemSection 